import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class AcceptAndSignTicketArgs extends ActionArgs {
  @Field(() => ID)
  ticketId: string

  @Field(() => String)
  username: string

  @Field(() => String)
  password: string

  @Field(() => ID, { nullable: true })
  driverId?: string
}

@ObjectType()
@InputType('AcceptAndSignTicketResultInput')
export class AcceptAndSignTicketResult {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  name: string

  @Field(() => Date)
  dateCreated: Date

  @Field(() => String)
  base64Signature: string

  @Field(() => String, { nullable: true })
  signatureUrl?: string
}
